<template>
  <div>
    <div class="registrationSurface">
      <div class="table_conent">
        <template>
          <div class="table_title">账号注册审核表</div>

          <el-table
            class="tableBox"
            style="height:100%"
            :header-cell-style="{background:'#F1F6F9',color:'#606266',width: '100%'}"
            :data="tableData"
            border
          >
            <el-table-column label="昵称" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.agent_name}}</span>
              </template>
            </el-table-column>

            <el-table-column label="手机号码" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.phone}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="dataTime" label="申请时间" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.create_date}}</span>
              </template>
            </el-table-column>
            <el-table-column label="申请理由" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.reason}}</span>
              </template>
            </el-table-column>

            <!-- <el-table-column label="经理分配" align="center" width="160">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.value"
                  placeholder="请选择"
                  @change="optionManager"
                  v-if="scope.row.status == 0"
                >
                  <el-option
                    v-for="item in selectData"
                    :key="item.agent_number"
                    :label="item.agent_name"
                    :value="item.agent_number"
                  ></el-option>
                </el-select>

                <span v-else>{{scope.row.agent_number}}</span>
              </template>
            </el-table-column> -->


            <el-table-column label="审核状态" align="center" :render-header="renderEmotionValue">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">已审核</span>
                <span v-if="scope.row.status == 0">未审核</span>
                <span v-if="scope.row.status == 2">驳回</span>
              </template>
            </el-table-column>

            <el-table-column label="操作" align="center" width="250">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="application(scope.row,1)"
                  v-if="scope.row.status == 0"
                >通过</el-button>
                <!-- v-if="scope.row.status == 0" -->
                <el-button
                  type="danger"
                  plain
                  size="mini"
                  class="table_btn"
                  @click="application(scope.row,2)"
                  v-if="scope.row.status == 0"
                >驳回</el-button>
                <el-button
                  type="primary"
                  size="mini"
                  class="table_btn"
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  disabled
                >审核通过</el-button>
                <el-button
                  type="info"
                  plain
                  size="mini"
                  class="table_btn"
                  v-if="scope.row.status == 1 || scope.row.status == 2"
                  disabled
                >驳回</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
    <div style="text-align: right;">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "",
      tableData: [],
      selectData: [
        {
          agent_name: "",
          agent_number: "",
          id: ""
        }
      ],
      parme: {
        params: {
          page: "1",
          page_size: "10",
          status: "3" //  0 未审核   1 、、已审核       2 驳回   3  全部
        }
      },
      agent_number: "",
      total: null
    };
  },
  created() {
    // this.initManager();
    this.initQuery();
  },
  methods: {
    // 初始化分配经理
    // initManager() {
    //   this.$http.get(this.$api.api.read_manage).then(res => {
    //     if (res.data.code != 1) {
    //       return this.$message.error(res.data.result);
    //     }
    //     this.selectData = res.data.result;
    //   });
    // },
    // 列表
    initQuery() {
      this.$http.get(this.$api.api.apply_list, this.parme).then(res => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.tableData = res.data.result;
        this.total = res.data.count;
      });
      //
    },
    // 通过申请 驳回
    application(data, type) {
      // if (!data.value) {
      //   return this.$message.error("请选择经理分配!");
      // }
      let status = "";
      if (type == 2) {
        status = type;
      } else {
        status = type;
      }
      let params = {
        id: data.id,
        agent_number: this.agent_number,
        status: Number(status)
      };

      this.$http.post(this.$api.api.one_register, params).then(res => {
        if (res.data.code != 1) {
          return this.$message.error(res.data.result);
        }
        this.$message.success(res.data.result);
        this.initQuery();
        this.agent_number = "";
      });
    },
    // 选择的区域经理
    optionManager(val) {
      this.agent_number = val;
      console.log(val);
    },
    renderEmotionValue(creatElement, { column, $index }) {
      return (
        <el-dropdown onCommand={this.handleCommand}>
          <span class="el-dropdown-link">
            审核状态 <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="3">全部</el-dropdown-item>
            <el-dropdown-item command="2">驳回</el-dropdown-item>
            <el-dropdown-item command="1">已审核</el-dropdown-item>
            <el-dropdown-item command="0">未审核</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      );
    },
    handleCommand(command) {
      console.log(command);
      console.log(this.parme.params.status);
      this.parme.params.status = command;
      this.initQuery();
    },
    // 分页
    handleCurrentChange(val) {
      this.parme.params.page = val;
      this.initQuery();
    }
  }
};
</script>

<style scoped lang="scss">
.registrationSurface {
  // padding: 10px;
  overflow: auto;
  .table_conent {
    padding-top: 10px;
    .table_title {
      border: 1px solid #ebeef5;
      border-bottom: 0px;
      text-align: center;
      font-size: 18px;
      font-weight: bold;
      height: 49px;
      line-height: 49px;
      background: #f1f6f9;
    }
    .table_btn {
      width: 80px !important;
    }
  }
}
.registrationSurface .table_conent .table_btn[data-v-6a5a20f6] {
  width: 100px !important;
}
.imgdelManger {
  cursor: pointer;
  padding-right: 20px;
}
</style>